export const STREAMLAIN_DOC_KIND_CUSTOM_PROPERTY_ID =
  'streamlain.docKind' as const;

export const STREAMLAIN_CUSTOM_APP_ROOT_DOC_KIND = 'custom-app-root' as const;

export function isStreamLainCustomAppRootDocKind(value: unknown): boolean {
  return value === STREAMLAIN_CUSTOM_APP_ROOT_DOC_KIND;
}
